import React from "react";
import Header from "../shared/Header";
import AgentChat from "../AgentChat";
import styled from "styled-components";

const Page = styled.div`
  max-width: 1280px;
  min-width: 1024px;
  margin: 0 auto;
  height: calc(100vh - 53px);
  max-height: calc(100vh - 53px);
  padding: 12px 16px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const ChatSlot = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

const AgentChatPage = () => {
  return (
    <>
      <Header />
      <Page>
        <ChatSlot>
          <AgentChat />
        </ChatSlot>
      </Page>
    </>
  );
};

export default AgentChatPage;
